/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function FaceIdIos16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.768 0A2.771 2.771 0 0 0 0 2.768v1.74a.651.651 0 0 0 1.302 0v-1.74c0-.808.658-1.466 1.466-1.466h1.74a.651.651 0 0 0 0-1.302h-1.74ZM.651 10.842a.651.651 0 0 0-.651.65v1.74A2.771 2.771 0 0 0 2.768 16h1.74a.651.651 0 0 0 0-1.302h-1.74a1.468 1.468 0 0 1-1.466-1.466v-1.74a.651.651 0 0 0-.65-.65Zm14.698 0a.651.651 0 0 0-.651.65v1.74c0 .808-.658 1.466-1.466 1.466h-1.74a.651.651 0 1 0 0 1.302h1.74A2.771 2.771 0 0 0 16 13.232v-1.74a.651.651 0 0 0-.651-.65ZM11.493 0a.651.651 0 0 0 0 1.302h1.739c.808 0 1.466.658 1.466 1.466v1.74a.651.651 0 1 0 1.302 0v-1.74A2.771 2.771 0 0 0 13.232 0h-1.74ZM9.984 10.139a.666.666 0 0 1 .904.979A4.246 4.246 0 0 1 8 12.246a4.24 4.24 0 0 1-2.888-1.13.666.666 0 0 1 .904-.979c.542.5 1.246.776 1.984.776s1.442-.275 1.984-.775ZM8.408 4.654a.666.666 0 0 0-.666.667v2.872H7.44a.666.666 0 1 0 0 1.332h.332c.718 0 1.302-.583 1.302-1.301V5.32a.666.666 0 0 0-.667-.667Zm2.835 0a.644.644 0 0 0-.643.644v1.164a.644.644 0 0 0 1.287 0V5.298a.644.644 0 0 0-.644-.644Zm-6.396 0a.644.644 0 0 0-.643.644v1.164a.644.644 0 0 0 1.287 0V5.298a.644.644 0 0 0-.644-.644Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
